module.exports = __webpack_public_path__ + "static/media/_MIC2458.image.51210329.png";